import { styled } from 'styled-components';

const StyledContainer = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledNoMatchPageContainer = styled.div`
  max-width: 500px;
`;

const StyledHeader = styled.header`
  text-align: center;
  margin-bottom: 30px;
`;

const StyledTitle = styled.h1`
  font-size: 24px;
  color: #333;
  margin-bottom: 10px;
`;

const StyledDescription = styled.p`
  color: #666;
  line-height: 1.5;
`;

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 24px;
  background-color: #0066cc;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #0052a3;
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
  }
`;

const StyledIcon = styled.span`
  margin-right: 8px;
  font-size: 16px;
`;

const NoMatchPage = () => {
  const handleReturnHome = () => {
    window.location.href = '/';
  };

  return (
    <StyledContainer>
      <StyledNoMatchPageContainer>
        <StyledHeader>
          <StyledTitle>Page not found</StyledTitle>
          <StyledDescription>Sorry, but the requested page does not exist.</StyledDescription>
        </StyledHeader>
        <StyledButton onClick={handleReturnHome}>
          <StyledIcon>🏠</StyledIcon>
          Return to main page
        </StyledButton>
      </StyledNoMatchPageContainer>
    </StyledContainer>
  );
};

export default NoMatchPage;
